export default (cart) => {
  const partnerID = localStorage.partner;
  const cartCount = cart.item_count;
  const partnerLogosArray = window.parnterLogos;
  const body = document.body;
  const MainContent = document.getElementById('MainContent');

  body.classList.add('print-shop');

  const partnerLogos = Array.from(partnerLogosArray);

  let partnerLogo = '';

  partnerLogos.forEach((logo) => {
    if (logo.includes('' + partnerID + '')) {
      partnerLogo = logo;
    }
  });

  MainContent.style.removeProperty('margin-top');

  return `
    <div id="shopify-section-header" class="shopify-section main-header print-shop-header">

      <header id="fn-main-header" class="main-header__wrapper">

        <div class="main-header__wrapper-left print-shop-desktop-links">

          <button id="fn-burger" type="button" class="main-header__burger">
            <div class="main-header__burger-inner"></div>
          </button>

          <button id="desktop-about-link" class="main-header__nav-header-dt">
            <span class="typo__header typo__header--medium">
              <a
                href="/pages/${partnerID}-about"
               >About</a>
            </span>      
          </button>   
        </div>

        <a href="/pages/${partnerID}" class="main-header__logo">
          <span class="logo-vendor"><img src="${partnerLogo}" style="width: 100px; height: auto;" /></span>
          <span class="logo-copy">Print shop</span>
        </a>

        <div class="main-header__wrapper-right">

          <button id="${cartCount == 0 ? `fn-cart-toggler` : `fn-cart-toggler`}" class="main-header__cart ${
    cartCount == 0 ? `main-header__cart--empty` : ``
  }">
            <svg class="main-header__cart-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="main-header__cart-full" d="M0 21.5385C0 22.8923 1.125 24 2.5 24H22.5C23.875 24 25 22.8923 25 21.5385V5.53846H19.2556C18.6656 2.39262 15.8638 0 12.5 0C9.13625 0 6.33438 2.39262 5.74438 5.53846H0V21.5385ZM12.5 1.23077C15.1719 1.23077 17.4094 3.07569 17.98 5.53846H7.02C7.59063 3.07569 9.82812 1.23077 12.5 1.23077Z" fill="#3300CC"/>
              <path class="main-header__cart-empty" d="M0 21.5385C0 22.8923 1.125 24 2.5 24H22.5C23.875 24 25 22.8923 25 21.5385V5.53846H19.2556C18.6656 2.39262 15.8638 0 12.5 0C9.13625 0 6.33437 2.39262 5.74438 5.53846H0V21.5385ZM12.5 1.23077C15.1719 1.23077 17.4094 3.07569 17.98 5.53846H7.02C7.59063 3.07569 9.82812 1.23077 12.5 1.23077ZM5.625 6.76923V10.4615H6.875V6.76923H18.125V10.4615H19.375V6.76923H23.75V21.5385C23.75 22.2172 23.1894 22.7692 22.5 22.7692H2.5C1.81062 22.7692 1.25 22.2172 1.25 21.5385V6.76923H5.625Z" fill="#262626" />
            </svg>
            <span class="main-header__cart-count fn-cart-count">${cartCount}</span>
          </button>

        </div>    

      </header>

      <nav class="main-header__mobile-menu" role="navigation">

        <div class="main-header__mobile-menu-inner">

          <div class="main-header__mobile-menu-wrap">
          
            <ul class="main-header__mobile-menu-list">
              <li class="main-header__mobile-menu-item">
                <a id="mobile-about-link" class="main-header__mobile-menu-link typo__paragraph typo__paragraph--big" href="/pages/${partnerID}-about" >About</a>
              </li>                       
            </ul>
          
          </div>

        </div>

      </nav>
    </div>
  `;
};
